import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { FormattedMessage } from 'react-intl'
import FormattedGoal from './FormattedGoal'
import styles from './_activeGoal.css'
import ActiveGoalDetails from './ActiveGoalDetails'
import Button from 'components/util/Button'

import {
  GOAL_ACTIVITY,
  GOAL_PERIODS,
} from '../shared/constants'

export default class ActiveGoal extends Component {
  static propTypes = {
    goal: PropTypes.object,
    stopGoalAction: PropTypes.func,
  }

  state = {
    showDetails: false,
  }

  handleToggleShowDetails = () => {
    this.setState({
      showDetails: !this.state.showDetails,
    })
  }

  handleStopGoal = (goalId) => {
    this.props.stopGoalAction(goalId)

    this.setState({
      showDetails: false,
    })
  }

  render () {
    const { goal } = this.props
    const { showDetails } = this.state

    const {
      tags,
      threshold_metrics,
    } = goal.criteria[0]

    const {
      value: goalThresholdValue,
      data_type_field: goalType,
    } = threshold_metrics[0][0]

    const verbLabel = GOAL_ACTIVITY[tags[0]] || <FormattedMessage id='goals.complete' defaultMessage='Complete ' />

    const periodLabel = (goal.period in GOAL_PERIODS) ? GOAL_PERIODS[goal.period] : ''
    let percentComplete = Math.floor((goal.performance.value / goalThresholdValue) * 100)

    if (isNaN(percentComplete)) {
      percentComplete = 0
    }

    const progressBarWidth = (percentComplete > 100) ? 100 : percentComplete

    return (
      <div className={styles.activeGoalContainer}>
        <Row>
          <Col xs={6} className={styles.goalDescription}>
            <Row>
              <Col xs={12}>
                <div className={styles.goalTarget}>
                  {verbLabel}
                  <FormattedGoal goalType={goalType} value={goalThresholdValue} />
                  {periodLabel}
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FormattedMessage
                  id='goals.completeness'
                  defaultMessage='{formattedGoal} complete'
                  values={{
                    formattedGoal: (
                      <FormattedGoal
                        goalType={goal.performance.data_type_field}
                        value={goal.performance.value} />
                    ),
                  }} />
              </Col>
            </Row>
          </Col>
          <Col xs={6}>
            <div className={styles.percentCompleteContainer}>
              <span className={styles.percentComplete}>
                {percentComplete}
              </span>
              <span className={styles.percentCompleteSymbol}>
                &#37;
              </span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className={styles.progressBar}>
              <div className={styles.progressBarFill} style={{
                width: `${progressBarWidth}%`,
              }} />
            </div>
          </Col>
        </Row>
        {showDetails ?
          <ActiveGoalDetails
            performanceMetrics={goal.progress.performance[0].metrics}
            startTime={goal.start_datetime}
            deleteGoal={() => this.handleStopGoal(goal._links.self[0].id)} /> : null}

        <Row>
          <Col xs={12}>
            <Button
              className={styles.showDetails}
              onClick={this.handleToggleShowDetails}
              el='button'
              type='secondary'
              size='small'>
              {!showDetails ?
                <FormattedMessage id='goals.showdetails' defaultMessage='Show details' />
              :
                <FormattedMessage id='goals.hidedetails' defaultMessage='Hide details' />}
            </Button>
          </Col>
        </Row>
      </div>
    )
  }
}
